import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators, ValidationErrors, FormBuilder, FormArray} from '@angular/forms';
import { LfsaBotonEditarGridComponent } from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import type { ColDef, SideBarDef, GridApi, GridOptions, GridReadyEvent } from "ag-grid-community";

import { logisticaModulo as diccionarios} from '../../logistica-diccionario';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { CentroAlmacen } from '../../../traslado-logist/model/asignacion-centro.model';
import { ITrackingViajes } from '../../model/modelTracking';
import { LogisticaService } from '../../service/logistica.services';
import { CatalogosLogisticaService } from '../../service/catalogosLogistica.service';
import SignaturePad from 'signature_pad';
import { ICheckDinamicoPreguntas, ICheckDinamicoRespuestas } from '../../model/modelCheckGarita';
import { IBasculaSentidoRequest, IMensajesRequest } from '../../model/modelOnlyServices';
import { UsuarioBasculaGaritaService } from 'src/app/aplicaciones-modulos/balanza/services/usuario-bascula-garita.service';
import { EquiposMarquesinaService } from '../../service/equiposMarquesinas.service';

@Component({
  selector: 'app-check-vehicular',
  templateUrl: './check-vehicular.component.html',
  styleUrls: ['./check-vehicular.component.css']
})
export class CheckVehicularComponent implements OnInit {

  public DAT_TITULOS    = diccionarios.titulos.vehicular;
  public GLOBAL_TITULOS = diccionarios.titulos.global;
  public DAT_AG_GRID = diccionarios.agGrid;

  public titleModal   : string;
  public loading      : boolean = false;
  public isCreate     : boolean = true;

  // variables para el grid
  public frameworkComponents: any;
  public columnDefs     : ColDef[] = [];
  public defaultColDef  : ColDef;
  public rowData        : any[] = [];
  public rowSelection   : any;
  public gridApi        : any;
  public gridColumnApi  : any;
  public textoBuscar    : string;

  public sideBar        : SideBarDef | string | string[] | boolean | null;
  public usarioActual   : any;

  // variables funcionales
  public cmbxEstados    : any[] = [];
  public listOpciones   : any[] = [];
  public routear        : "garita";
  public fechaHoraIncio : any;

  //FIRMA
  signatureNeeded!  : boolean;
  signaturePad!     : SignaturePad;
  @ViewChild('canvas') canvasEl!: ElementRef;
  //@ViewChild('canvas') canvasEl!: ElementRef<HTMLCanvasElement>;

  //@ViewChild('canvas', { static: true }) canvasEl!: ElementRef<HTMLCanvasElement>;

  signatureImg!     : string;

  public checkTodos = new FormControl(false);
/*
  public formulario = new FormGroup({
    viajeId           : new FormControl('', Validators.required),
    filtracionFront   : new FormControl('', Validators.required),
    filtracionLeft    : new FormControl('', Validators.required),
    filtracionRight   : new FormControl('', Validators.required),
    filtracionPiso    : new FormControl('', Validators.required),
    filtracionUp      : new FormControl('', Validators.required),
    puertas           : new FormControl('', Validators.required),
    exterior          : new FormControl('', Validators.required),
    estructura        : new FormControl('', Validators.required),
    luces             : new FormControl('', Validators.required),
    ruedas            : new FormControl('', Validators.required),
    limpieza          : new FormControl('', Validators.required),
    fumigacion        : new FormControl('', Validators.required),
    firma             : new FormControl(''),
    observacion       : new FormControl(''),
    estado            : new FormControl('', Validators.required),
    urlFirma          : new FormControl(''),
    urlFoto           : new FormControl(''),
    //adjuntos          : new FormControl(''),

    creadoPor         : new FormControl(''),
    modificadoPor     : new FormControl(''),
    proveedorNombre   : new FormControl(''),
    placa             : new FormControl(''),
    });*/
  //MODELO DINAMICO
  public formulario: FormGroup;
  public tipoCheck;

  public ESTADO_CHECK_GESTION = "GARITA_APROBADO";

  constructor(
    private utilServices    : UtilsService,
    private logisticaAPI    : LogisticaService,
    private _catalogos      : CatalogosLogisticaService,
    private fb              : FormBuilder,

    /**Integracion de servicios con equipos y sensores */
    private onlyControlSensoresAPI: EquiposMarquesinaService,
    private usuarioBasculaAPI: UsuarioBasculaGaritaService,
  ) { }

  ngOnInit(): void {
    this.usarioActual = JSON.parse(localStorage.getItem('datosUsuarioLogin'));
    this.cargarGridcomponent();
    this.inicializar();

    //Check o UnCheck Todos
    this.checkTodos.valueChanges.subscribe(valor => {
      let values = valor ? '1' : '0';
      this.listOpciones.forEach(e=> this.formulario.get(e.name).setValue(values));

      if(this.preguntasDinamicas) this.checkTodoDinamicos(values);//MODELO DINAMICO

    });

    this.formulario = this.fb.group({
      viajeId           : ['', Validators.required],
      filtracionFront   : ['', Validators.required],
      filtracionLeft    : ['', Validators.required],
      filtracionRight   : ['', Validators.required],
      filtracionPiso    : ['', Validators.required],
      filtracionUp      : ['', Validators.required],
      puertas           : ['', Validators.required],
      exterior          : ['', Validators.required],
      estructura        : ['', Validators.required],
      luces             : ['', Validators.required],
      ruedas            : ['', Validators.required],
      limpieza          : ['', Validators.required],
      fumigacion        : ['', Validators.required],
      firma             : [''],
      observacion       : [''],
      estado            : [''],
      urlFirma          : [''],
      urlFoto           : [''],

      creadoPor         : ['', Validators.required],
      modificadoPor     : [''],
      proveedorNombre   : [''],
      placa             : [''],
      //grupoDinamico     : this.fb.array([]),
    });


    // Para obtener api key de bascula para integracion Only Control
    this.getAllMensajesMarquesinas();
    this.getUsuarioBascula();
  }

  get grupoDinamicoForm(){
    return this.formulario.get('grupoDinamico') as FormArray;
  }

  ngAfterViewInit() {
    this.signaturePad = new SignaturePad(this.canvasEl.nativeElement);
    console.log("Canva de firma", this.canvasEl.nativeElement);
  }

  //{ cellRenderer: 'buttonRenderer', cellRendererParams: {onClick: this.gestionarRevision.bind(this), label: '=> Gestionar'} }
  cargarGridcomponent() {
    this.frameworkComponents = { buttonRenderer: LfsaBotonEditarGridComponent, };
    this.columnDefs = this._catalogos.getColumnDefs();
    this.columnDefs.push(
      { cellRenderer: 'buttonRenderer', initialPinned:"left", cellRendererParams: {onClick: this.nuevo.bind(this), label: 'Editar'} },
    );

    // Habilitar o deshabilitar según necesidad
    this.defaultColDef = this._catalogos.getDefaultColDef();;
    this.sideBar = "columns";
  }

  onQuickFilterChanged() {
    this.gridApi.setQuickFilter(this.textoBuscar);
  }

  onGridReady(params) {
    this.gridApi       = params.api;
    this.gridColumnApi = params.columnApi;

    /*
    params.api.addCellRange({
      rowStartIndex: 1,
      rowEndIndex: 5,
      columns: ["placa", "choferCedula", "choferNombre", "proveedorId"],
    });
  */

  }

  inicializar(){
    this.cmbxEstados  = this._catalogos.catalogoEstados();
    this.listOpciones = this._catalogos.catalogoPreguntasVehicular();
    this.checkTodos.reset();
    this.listar();
  }

  listar(){
    this.selected = null;
    this.rowData = null;
    
    this.logisticaAPI.getViajesByEstadoRevisionFisica().subscribe((res) => {
      if(res) this.rowData = res;
    }, (err) => {
      console.log(err.message);
    });
  }

  selected : ITrackingViajes;
  nuevo({rowData}){
    this.ngOnInit(); // revisar mejora para no llamar siempre el listado
    this.preguntasDinamicas = [];
    this.tipoCheck = "";

    this.selected = rowData;
    this.isCreate = true;
    let control   = false;

    console.log("viaje seleccionado", this.selected);
    this.titleModal = this.GLOBAL_TITULOS.tituloAgregar;
    this.fechaHoraIncio = this.utilServices.getFechayHoraActual();
    this.checkTodos.reset();
    this.formulario.reset();
    this.formulario.get('viajeId').setValue(rowData.idViaje);
    //verificar esto kary
    this.listOpciones.forEach(e=> {this.formulario.get(e.name).addValidators(Validators.required)});
    this.formulario.updateValueAndValidity();

    //Verifica si check ya existe
    //this.formulario.get('viajeId').setValue(res.viaje.idViaje);
    this.logisticaAPI.getByViajeCheckVehicular(rowData.idViaje).subscribe((res) => {
      if(res) {
        this.formulario.patchValue(res);
        this.formulario.get('firma').setValue(res.firma ? 1 : 0);
        this.formulario.get('modificadoPor').setValue(this.usarioActual.login2);
        control = true;
        console.log("control y estado", control, rowData.estado);
        
        this.isCreate   = false;
        this.titleModal = this.GLOBAL_TITULOS.tituloActualizar;
        console.log("Check seleccionado", res);
        //this.gestionarRevision({rowData});
      }
    }, (err) => { //"HttpErrorResponse"
      console.warn(err.message); 
      console.warn('Error en consulta', err.status +' - '+ err.error.mensaje); 
      
      this.formulario.get('creadoPor').setValue(this.usarioActual.login2)
      this.formulario.get('viajeId').setValue(rowData.idViaje)

      if(rowData.estado == this.ESTADO_CHECK_GESTION && !control){
        this.utilServices.mensajeOKToast("Se gestionará un nuevo Check de Garita");
        //this.openModal();
      }

      //INICIA EL PROCESO CON REVISIÓN VEHICULAR
      if(rowData.tipoCarga == 2){
          //this.tipoCheck = 'REVISION_VEHICULAR';
          this.tipoCheck =  rowData.estado == "REVISION_CALIDAD_HABILITADA" ? "GARITA" : "OPERADOR";
          console.log(this.tipoCheck + rowData.tipoCarga);
          this.getCheckGranel(this.tipoCheck);
      }

    });

    //Inicializa firma
    //Esperamos a que Angular renderice el canvas
    setTimeout(() => {
      if (this.canvasEl) {
        this.signaturePad = new SignaturePad(this.canvasEl.nativeElement);
      } else {
        console.error('canvasEl no está disponible todavía');
      }
    }, 0);

  }

  gestionarRevision({rowData}){
    this.isCreate   = false;
    this.titleModal = this.GLOBAL_TITULOS.tituloActualizar;
    this.formulario.reset();
    console.log("Seleccionado... gestionar revisicion", rowData);

    this.logisticaAPI.getByViajeCheckVehicular(rowData.idViaje).subscribe((res) => {
      if(res){
        res.modificadoPor = this.usarioActual.login2;
        this.formulario.patchValue(res);
        this.formulario.get('firma').setValue(res.firma ? 1 : 0);
        this.formulario.get('modificadoPor').setValue(this.usarioActual.login2);
        console.log("Check seleccionado", res);
        //this.openModal();
      }
    }, (err) => { console.log(err.message); });

  }

  /** Si el form esta en modo de creación hará post caso contrario un update, ver variable isCreated */
  saveForm() {
    this.getFormValidationErrors();
    if (this.formulario.invalid) return;

    let payload  = this.formulario.getRawValue();
    payload.viaje= this.selected;
    payload.firma= payload.firma ? 1 : 0;
    payload.fechaInicioProceso = this.fechaHoraIncio;

    if(this.isCreate){
      this.signatureNeeded = this.signaturePad.isEmpty();
      if (this.signatureNeeded) return this.utilServices.mensajeErrorVisto("Se requiere firmar");

      this.savePad();
      payload = this.setFormData(payload);
    }

    this.loading = true;
    console.log("payload", payload);

    let mensajeP = this.isCreate ? diccionarios.mensajes.guardar : diccionarios.mensajes.actualizar;

    this.utilServices.confirmarSincronoPromesa({
        title   : mensajeP,
        text    : this.DAT_TITULOS.titulo,
        action  : this.titleModal,
        funcion : this.isCreate ? this.logisticaAPI.createCheckVehicular(payload) : this.logisticaAPI.updateCheckVehicular(payload)
      }).then((res: any) => {
        //this.closeModal();
        this.isCreate = false;
        this.listar();

        if(this.basculaUsuario?.sensorId != null){
            this.enviarMensajeMarquesina(res.estado);
        }        

      }).catch(() => {});

      this.loading = false;
  }

  acciones(event) {
    if(event === 'regresar') {
      this.selected = null;
      this.closeModal();
      return;
    };

    if(this.selected.tipoCarga == 2) return this.saveFormModeloNuevo(); // MODELO DINAMICO
    this.saveForm();
  }

  openModal() {
    document.getElementById('abrirModal').click();
  }

  closeModal() {
    document.getElementById('cerrarModal').click();
  }

  onKeydown(event) {
    console.log(event);

    if ((event.key === 'Enter' && this.formulario.valid === true)){
        console.log('ENTER --> KEYDOWN');
      }

  }

  getFormValidationErrors() {
    console.log('%c ==>> Validation Errors: ', 'color: red; font-weight: bold; font-size:25px;');
    let totalErrors = 0;

    Object.keys(this.formulario.controls).forEach(key => {
      const controlErrors: ValidationErrors = this.formulario.get(key).errors;
      if (controlErrors != null) {
        totalErrors++;
        Object.keys(controlErrors).forEach(keyError => {
          console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
        });
      }
    });

    console.log('Number of errors: ', totalErrors);
  }

  /** METODOS DE CONSULTAS  */
  actualizarEstadoViaje({rowData}){
    const data = rowData;

    this.utilServices.confirmarSincronoPromesa({
        title   : "¿Esta seguro que desea enviar a balanza el viaje?",
        text    : 'VIAJE ' + rowData.idViaje,
        action  : "Actualizar Viaje",
        funcion : this.logisticaAPI.updateViaje(data)
      }).then(() => {
        this.loading = false;
        this.listar();
        this.closeModal();
      }).catch(() => {
        this.loading = false;
      });
  }

  /* METODOS DE LA FIRMA */
  startDrawing(event: Event) {
      // works in device not in browser
  }

  moved(event: Event) {
      // works in device not in browser
  }

  // luego agregar esto al form data para enviar el formulario
  savePad() {
    //const base64Data = this.signaturePad.toDataURL("image/jpeg");
    const base64Data = this.signaturePad.toDataURL();
    this.signatureImg = base64Data;

    console.log(`Tamaño aproximado firma base64: ${Math.round(base64Data.length / 1024)} KB`);

    this.signatureNeeded = this.signaturePad.isEmpty();
    if (!this.signatureNeeded) {
      this.signatureNeeded = false;
    }
  }

  clearPad() {
    this.signaturePad.clear();
  }

  //Manejo de imagenes
  imagenes: File[] = [];
  errorArchivos: string = '';
  onFileSelected(event: Event){
    const fileInput = event.target as HTMLInputElement;
    if (!fileInput.files) return;

    const archivos = Array.from(fileInput.files);
    const archivosValidos = archivos.filter(file =>
      ['image/png', 'image/jpeg'].includes(file.type)
    );

    if (archivosValidos.length !== archivos.length) {
      this.errorArchivos = 'Algunos archivos no son PNG o JPG válidos.';
      this.imagenes = [];
      return;
    }

    this.imagenes = archivosValidos;
    this.errorArchivos = '';
  }


  //formData.append('fotos', file, file.name)
  setFormData(data: any): FormData {
    const formData = new FormData();
    if (this.imagenes.length > 0) {
      this.imagenes.forEach((file) => {formData.append('imagenes', file);}); // archivos
    }

    Object.entries(data).forEach(([key, value]) =>formData.append(key, value as string)); // campos texto
    formData.delete('viaje');
    formData.append('capturaFirma', this.signatureImg);
    formData.append('viaje',JSON.stringify(data.viaje));

    return formData;
  }

  /**Adaptaciones para check nuevos
   * Registros RE-10200B, pregunta por partes según modulo
   * Modelo de maestro de preguntas y respuestas
   * Renderización de formulario dinamico
  */
  preguntasDinamicas: ICheckDinamicoPreguntas[]=[];
  getCheckGranel(modulo: string){
    this.logisticaAPI.getCheckByRegistroModulo('RE-10200B', modulo).subscribe((res) => {
      if(res){
        this.preguntasDinamicas = res;
        this.preguntasDinamicas.forEach(e=> {e.renderControl = 'pregunta_' + e.idItem});
        console.log("nuevas preguntas", this.preguntasDinamicas);
        this.formulario.get('estado').addValidators(Validators.required);
        this.formulario.updateValueAndValidity();
      }
    }, (err) => { console.info(err.message); });
  }

  addPreguntas(res){
    this.formulario.clearValidators();
    res.forEach(e => {
      const preguntaGroup = this.fb.group({
        id        : [e.idItem],
        respuesta : ['', Validators.required]
      });
      this.grupoDinamicoForm.push(preguntaGroup);
    });
    this.formulario.updateValueAndValidity();
  }

  dataRespuestas(){
    let respuestas: ICheckDinamicoRespuestas[]=[];
    this.preguntasDinamicas.forEach(e=>{
      const item = {
        viajeId : this.selected.idViaje,
        itemId  : e.idItem,
        respuestaCheck : e.tipoRespuesta == "SI_NO_NA" ? this.formulario.get(e.renderControl)?.value : null,
        respuestaTexto : e.tipoRespuesta == "TEXT" ? this.formulario.get(e.renderControl)?.value : "-",
        respuestaNum   : e.tipoRespuesta == "NUMBER" ? this.formulario.get(e.renderControl)?.value : 0,
        inspeccionadoPorUsuario : this.usarioActual.login2,
        inspeccionadoPorCedula : this.usarioActual.login,
        urlFirma: null,
        urlFotos : null,
        creadoPor : this.usarioActual.login2,
        checklistMaestro: e,
        itemPregunta: e.idItem,
        tipoRespuesta : e.tipoRespuesta,
        estadoViaje: this.formulario.get('estado').value
      };
      respuestas.push(item);
    });
    console.log("preguntas para enviar a crear respuesta dinamicas", respuestas);

    const formData = new FormData();
    if (this.imagenes.length > 0) {
      this.imagenes.forEach((file) => {
        formData.append('imagenes', file);
      });
    }

    //Object.entries(respuestas).forEach(([key, value]) =>formData.append(key, value as string)); // campos texto
    formData.append('capturaFirma', this.signatureImg);
    formData.append('respuestas',  JSON.stringify(respuestas));
    //stringify

    return formData;
  }

  checkTodoDinamicos(value){
    this.preguntasDinamicas.forEach(e => {
      if(e.tipoRespuesta == 'SI_NO_NA' ){
        this.formulario.get(e.renderControl).setValue(value);
        this.formulario.get(e.renderControl).markAsTouched();
      }
    });
  }

  saveFormModeloNuevo() {
    this.getFormValidationErrors();
    if (this.formulario.invalid) return;

    if(this.isCreate){
      this.signatureNeeded = this.signaturePad.isEmpty();
      if (this.signatureNeeded) return this.utilServices.mensajeErrorVisto("Se requiere firmar");
      this.savePad();
    }
    let payload  = this.dataRespuestas();
    let mensajeP = this.isCreate ? diccionarios.mensajes.guardar : diccionarios.mensajes.actualizar;
    this.loading = true;
    console.log("data a enviar", payload);
    this.utilServices.confirmarSincronoPromesa({
        title   : mensajeP,
        text    : this.DAT_TITULOS.titulo,
        action  : this.titleModal,
        funcion : this.logisticaAPI.createCheckByRespuestasListMultipart(payload)
      }).then(() => {
        this.listar();
        this.closeModal();
      }).catch(() => {});
      this.loading = false;
  }

  isViajeConcurrente = false;
  getCheckRespuestas(){
    this.logisticaAPI.getCheckByRespuestas(this.selected.idViaje).subscribe((res) => {
      if(res){
        this.isViajeConcurrente = true;
      }
    }, (err) => { console.info(err.message); this.isViajeConcurrente = false;});
  }


  /**INTEGRACION ONLY CONTROL
   * USUARIO Y BALANZA, INICIALIZA SERVICIOS Y ENVIA MENSAJES
   */
  
  //Obtiene el usuario para garita o bascula
  basculaUsuario : any;
  getUsuarioBascula(){
    const username =this.usarioActual.login2;
    this.usuarioBasculaAPI.obtenerPorUsuario(username, "bascula").subscribe(
      resp => {
        if (resp?.bascula) {
          let bascula = {
            idBascula: resp.bascula, 
            estado: resp.estadoBascula, 
            desca: resp.basculaDescripcion,
            sensorId: resp.sensorId,
            apiKey: resp.apiKey,
          };
          this.basculaUsuario = bascula;

          //Verifica test de conexión siempre que tenga Api Key
          if (resp.sensorId != null) {
            this.onlyControlSensoresAPI.setIntegration_ApiKey(resp.sensorId);
          }
          return;
        }
      },
      e => {console.error('Mensaje: ', e.error.mensaje, 'Respuesta', e.error.respuesta);}
    );
  }

  mensajesMarquesinas=[]; 
  getAllMensajesMarquesinas(){
    this.logisticaAPI.getMarquesinaMensajes().subscribe(resp => {
      if(resp){
        this.mensajesMarquesinas = resp;
      }
      console.log("mensajes marquesiana", this.mensajesMarquesinas);
    });
  }

  enviarMensajeMarquesina(tipoMensaje: String){
    console.log("buscar mensaje según estado", tipoMensaje);
    let filterMnsj = this.mensajesMarquesinas.find(e=> e.tipo === tipoMensaje);
    let lineasMnsj = filterMnsj ? filterMnsj.mensaje.split(",").map(m => ({texto: m.trim()})) : [];

    if(filterMnsj.indicador > 0) this.setearSentidoBascula(filterMnsj.indicador);

    if(lineasMnsj.length == 0){
      console.info("Marquesina sin mensajes", lineasMnsj.length);
      this.utilServices.alertifyToastWar("Sin mensajes para marquesina " + filterMnsj.marquesina.codigo);
      return;
    }

    const request: IMensajesRequest = {
      codigoBascula     : filterMnsj.marquesina.codigo,
      mensajesMarquesina: lineasMnsj
    };

    this.onlyControlSensoresAPI.postMensaje(request).subscribe(
      (resp) => {
        console.log(resp);
        if(resp.error == 1){
          this.utilServices.mensajeErrorVisto("Error de Envio de mensajes", resp.detalle, 3000);    
          return; 
        }
        this.utilServices.alertifyToastOK("Mensaje de entrada enviado a la marquesina");
      },
      (error) => {
        this.utilServices.mensajeErrorVisto("Error en establecer mensaje");
        console.log("Error en establecer mensaje", error);
      }
    );
  }

  //Recibe sentido 1 o 2 dependiente si es Entrada o Salida
  setearSentidoBascula(sentido: number){
    const request: IBasculaSentidoRequest = {
      codigoBascula: this.basculaUsuario.sensorId,
      sentido: sentido
    };
    
    this.onlyControlSensoresAPI.postSentidoBascula(request).subscribe(
      (resp) => {
        this.utilServices.alertifyToastOK("Sentido establecido");
        if(resp.error == 1){
          this.utilServices.mensajeErrorVisto("Error en establicer sentido", resp.detalle, 3000);
          return;
        }
      },
      (error) => {
        this.utilServices.mensajeErroToast("Error en establecer sentido");
        console.log("Error en establecer sentido", error);
      }
    );
  }
  
}
